import { Dispatch, FunctionComponent, SetStateAction, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import StandardButton from 'design-system/Buttons/StandardButton'

import Spacer from 'components/Spacer'

import * as E from 'types/enums'

import HomeTypeSelectionInput from '../SelectionInputs/HomeTypeSelectionInput'
import { IMobileSheetProps } from '../types'
import MobileFilterSheet from './Shared/MobileFilterSheet'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

interface IProps {
  selectedHomeTypes: E.HomeTypeEnum[]
  setSelectedHomeTypes: Dispatch<SetStateAction<E.HomeTypeEnum[]>>
  onApply: () => void
  onReset: () => void
}

const HomeTypeMobileSheet: FunctionComponent<IProps & IMobileSheetProps> = ({
  selectedHomeTypes,
  setSelectedHomeTypes,
  onApply,
  onReset,
  visible,
  showMobileFilterSheet,
  hideMobileFilterSheet,
}) => {
  const theme = useContext(ThemeContext)

  const setHomeTypeFilterSheet = (newVisible: boolean) => {
    if (newVisible) showMobileFilterSheet()
    else hideMobileFilterSheet()
  }

  const handleClickApply = () => {
    onApply()
    hideMobileFilterSheet()
  }

  return (
    <MobileFilterSheet
      height={300}
      visible={visible}
      setVisible={setHomeTypeFilterSheet}
      onClose={hideMobileFilterSheet}
    >
      <Container>
        <HomeTypeSelectionInput
          selectedHomeTypes={selectedHomeTypes}
          setSelectedHomeTypes={setSelectedHomeTypes}
        />
        <Spacer size={theme.spacings[24]} />
        <StandardButton
          type="primary"
          label="Apply"
          size="medium"
          onClick={handleClickApply}
          fullWidth
        />
        <Spacer size={theme.spacings[4]} />
        <StandardButton
          type="tertiary"
          label="Reset"
          size="small"
          disabled={!selectedHomeTypes.length}
          onClick={onReset}
          fullWidth
        />
      </Container>
    </MobileFilterSheet>
  )
}

export default HomeTypeMobileSheet
